import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import TableImage from "../../../../Componets/Image";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import { get_all_purchases_returns } from "../../../../Controllers/Purchases/Returns";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Purchases/Return/tables";
import headers from "../../../../Data/Tables/Purchases/Return/headers";
import ValueTag from "../../../../Componets/Valuetag";
import Loadercomponent from "../../../../Componets/Loader";
import moment from "moment";
import { useLocation } from "react-router-dom";

const PurchasesReturnsTable = () => {
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      supplier: headerdata?.supplier,
      contractor: headerdata?.contractor,
      date: headerdata?.date,
      due_date: headerdata?.due_date,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        supplier: tabledata?.supplier,
        contractor: tabledata?.contractor,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
        page: tabledata?.currentPage,
      };

      const purchases_returns = await get_all_purchases_returns(data);
      if (purchases_returns?.status) {
        let data = [];

        purchases_returns?.data?.data?.map((value, index) => {
          const paidAmount =
            value?.payments?.reduce(
              (sum, payment) => sum + Number(payment.amount || 0),
              0,
            ) || 0;

          const remainingAmount = (value?.total || 0) - paidAmount;
          data?.push({
            path:
              location?.pathname == "/app/billing"
                ? `/app/billing/view/${value?._id}`
                : `/app/purchases/returns/view/${value?._id}`,
            Number: `#PR-${value?.number}`,
            Supplier: value?.supplier?.name ? value?.supplier?.name : "",
            Date: moment(value?.date).format("MMMM Do YYYY"),
            Due: moment(value?.due_date).format("MMMM Do YYYY"),
            Delivery:
              value?.delivery_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Delivered
                </span>
              ) : value?.delivery_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Pending
                </span>
              ),
            Payment:
              value?.payment_status == 2 ? (
                <div className="flex items-center gap-3 bg-emerald-50/50 px-3 py-2 rounded-lg border border-emerald-200">
                  <span className="text-emerald-600 font-medium text-sm">
                    Paid{" "}
                  </span>
                </div>
              ) : value?.payment_status == 1 ? (
                <div className="bg-amber-50/50 p-3 rounded-lg border border-amber-200 min-w-[150px]">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-amber-700 font-medium text-sm">
                      Partial
                    </span>
                    <span className="text-xs text-gray-500">
                      {(
                        (paidAmount / (paidAmount + remainingAmount)) *
                        100
                      ).toFixed(0)}
                      %
                    </span>
                  </div>
                  <div className="space-y-1.5">
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">Paid</span>
                      <span className="text-emerald-600 font-semibold">
                        {paidAmount.toFixed(3)}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">Remaining</span>
                      <span className="text-red-600 font-semibold">
                        {remainingAmount.toFixed(3)}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex items-center gap-3 bg-red-50/50 px-3 py-2 rounded-lg border border-red-200">
                  <span className="text-red-600 font-medium text-sm">
                    Unpaid
                  </span>
                </div>
              ),
            Status: <Status status={value?.status} />,
            Amount: value?.total?.toFixed(3),
            Action: (
              <ActionButton
                edit={`/app/purchases/returns/edit/${value?._id}`}
                id={value?._id}
                api="delete-purchases-return"
                actiondata={actiondata}
                headers={header}
              />
            ),
          });
        });

        setPagination({
          currentPage: purchases_returns?.data?.currentPage,
          totalCount: purchases_returns?.data?.totalCount,
          totalPages: purchases_returns?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(purchases_returns?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default PurchasesReturnsTable;
